import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ShieldCheck } from "lucide-react";

export const ConsentDialog = ({ open, onOpenChange, onConfirm, title, statement, description, confirmLabel = "Confirm & continue", testId = "consent" }) => {
  const [ok, setOk] = useState(false);
  const close = (o) => { if (!o) setOk(false); onOpenChange(o); };
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md" data-testid={`${testId}-dialog`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-teal-700" /> {title}</DialogTitle>
          <DialogDescription>{description || "Prerecorded voicemails are regulated by the TCPA and state telemarketing laws. You are responsible for having consent before contacting anyone."}</DialogDescription>
        </DialogHeader>
        <label className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm font-semibold text-amber-900">
          <Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} className="mt-0.5" data-testid={`${testId}-checkbox`} />
          {statement}
        </label>
        <DialogFooter>
          <Button variant="ghost" onClick={() => close(false)} data-testid={`${testId}-cancel`}>Cancel</Button>
          <Button disabled={!ok} onClick={() => { close(false); onConfirm(); }} className="bg-slate-900 hover:bg-slate-800" data-testid={`${testId}-confirm`}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
